// @ts-nocheck


import React from 'react';
import styled, { css } from 'styled-components';
import { Tabs } from '../../../components/ui';

export const SectionContent = styled.div.withConfig({ displayName: "elements__SectionContent", componentId: "sc-1t9qer-0" })(["padding:16px;overflow-x:auto;"]);




export const HeaderCellText = styled(({ sticky, center, ...props }) =>
<p {...props} />
).withConfig({ displayName: "elements__HeaderCellText", componentId: "sc-1t9qer-1" })(["color:#4c4c4c;font-size:12px;font-weight:bold;", " ", ""],



(props) =>
props.center &&
css(["width:100%;text-align:center;"]),



(props) =>
props.sticky &&
css(["position:sticky;margin:0 32px;width:auto;left:16px;text-align:left;"]));







HeaderCellText.defaultProps = {
  center: true
};

export const Cell = styled(({ index, ...props }) => <div {...props} />).withConfig({ displayName: "elements__Cell", componentId: "sc-1t9qer-2" })(["border-right:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5;height:35px;display:flex;justify-content:center;align-items:center;font-size:12px;color:#838383;user-select:none;"]);











export const StyledTabs = styled(Tabs).withConfig({ displayName: "elements__StyledTabs", componentId: "sc-1t9qer-3" })(["& .tabs__item{font-weight:bold;}"]);





export const Buttons = styled.div.withConfig({ displayName: "elements__Buttons", componentId: "sc-1t9qer-4" })(["display:flex;justify-content:flex-end;width:100%;& > *{margin-right:16px;&:last-child{margin-right:0;}}"]);
